/* eslint-disable no-undef */

const studySmarterToastComponent = () => {
  const toast = document.querySelector('.js-study-smarter-box-toast');
  const icon = document.querySelector('.js-study-smarter-box-toast-icon');
  const close = document.querySelector('.js-study-smarter-box-toast-close');
  const content = document.querySelector('.js-study-smarter-box-toast-content');

  const bindEvents = () => {
    icon.addEventListener('click', maximize);
    close.addEventListener('click', minimize);
  };

  const defineComponentState = () => {
    if ($.cookie('_sofatutor_study_smarter_toast_component')) {
      toast.classList.remove('hide');
    }

    if ($.cookie('_sofatutor_study_smarter_toast_component') == 'icon') {
      icon.classList.remove('hide');
    } else {
      content.classList.remove('hide');
    }
  };

  const minimize = () => {
    $.cookie('_sofatutor_study_smarter_toast_component', 'icon', { path: '/' });
    content.classList.remove('animate__fadeIn');
    content.classList.add('animate__fadeOut');
    icon.classList.remove('animate__fadeOut', 'hide');
    icon.classList.add('animate__fadeIn');
  };

  const maximize = () => {
    $.cookie('_sofatutor_study_smarter_toast_component', 'content', { path: '/' });
    icon.classList.remove('animate__fadeIn');
    icon.classList.add('animate__fadeOut');
    content.classList.remove('animate__fadeOut', 'hide');
    content.classList.add('animate__fadeIn');
  };

  defineComponentState();
  bindEvents();
};

document.addEventListener('turbolinks:load', () => {
  if (
    document.querySelector('.visitors-video-page .js-study-smarter-box-toast')
  ) {
    studySmarterToastComponent();
  }
});
